<script>
    import Image from "./Image.svelte";

    export let id;
    export let value;
    export let current;
    export let label;
    export let placeholder = "";
    export let fa = true;
    export let icon = null;
    export let reset = true;
    export let required = false;
    export let margin = true;
    export let readonly = false;
    export let maxlength = 1024;
    export let rows = 5;
</script>

<div class="form-group" class:in={current === id} class:filled={value} class:readonly class:margin>
    <!-- label -->
    <label class="sr-only" required for={id}>{label}</label>

    <!-- icon -->
    {#if icon != null}
        <div class="icon-left">
            {#if fa}
                <i class={icon} />
            {:else}
                <Image src={icon} />
            {/if}
        </div>
    {/if}

    <textarea
        class="form-control"
        on:focus={(e) => (current = id)}
        on:blur={() => (current = null)}
        bind:value
        {required}
        name={id}
        {rows}
        {maxlength}
        {placeholder}
        {readonly}
        autocomplete="off" />

    <!-- reset button -->
    {#if reset}
        <div class="icon-right reset">
            <button on:click={() => (value = null)} type="button" class="reset" tabindex="-1">
                <i class="fa fa-times-circle" />
            </button>
        </div>
    {/if}

    <!-- custom button -->
    <slot />
</div>

<style>
    .form-group {
        display: flex;
        position: relative;
        width: 100%;
        border-radius: 2px;
        background: #efefef;
    }
    .margin.form-group {
        margin-bottom: 15px;
    }

    .readOnly.form-group {
        background: none;
    }

    .in.form-group {
        -webkit-box-shadow: 0 2px 0 var(--primary-light-color);
        box-shadow: 0 2px 0 var(--primary-light-color);
    }
    .in.form-group .icon-left {
        color: var(--primary-color);
    }
    .form-group .icon-left {
        width: 34px;
        padding-top: 10px;
        font-size: 17px;
        font-weight: 400;
        line-height: 1;
        text-align: right;
        background-color: #eee;
        border: 0;
        color: var(--primary-light-color);
    }

    .form-group .icon-right {
        background: 0;
        cursor: pointer;
        padding: 10px 8px 0 5px;
    }

    .form-group:not(.filled) div.reset {
        visibility: hidden !important;
    }

    .form-group .form-control {
        position: relative;
        width: 100%;
        margin-bottom: 0;
        background: #efefef;
    }

    .form-group input {
        -webkit-appearance: none;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        color: #666;
        font-size: 14px;
        height: 40px;
        padding-left: 10px;
        padding-right: 10px;
        resize: none;
        vertical-align: middle;
        width: 100%;
    }

    .form-group button {
        display: block;
    }

    .form-group button:not(:disabled):active {
        background-color: #efefef;
    }

    .form-group button.reset {
        cursor: pointer;
        background: none;
        color: #ccc;
        font-size: 18px;
        border: 0;
        border-radius: 0;
        -webkit-box-shadow: none;
        box-shadow: none;
        margin: 0;
        padding: 0;
        text-align: left;
    }

    textarea {
        resize: none;
        border: none;
        overflow: auto;
        outline: none;
    }
</style>
